import { Persistor } from 'redux-persist';

let persistorRef: Persistor | null = null;

export const setPersistorRef = (persistor: Persistor) => {
  persistorRef = persistor;
};

export const persistorFlush = (): Promise<void> => (
  persistorRef ? persistorRef.flush() : Promise.resolve()
);

export const persistorPurge = (): Promise<void> => (
  persistorRef ? persistorRef.purge() : Promise.resolve()
);

export const clearPersistedStorage = async (): Promise<void> => {
  localStorage.removeItem('selectedFarmId');
  localStorage.removeItem('selectedAccount');
  await persistorPurge();
};
